import { useCallback } from "react"
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { StorageService } from "../../../services";
import { useAxios } from "../../../contexts/AxiosContext";
import { AUTH_TOKEN_KEY, SELECTED_WORKSPACE_KEY, USER_DETAILS_KEY } from "../../../constants";
import { useAuthService } from "../services/useAuthService";

type logoutType = (navigateToAfter?: string) => void

const useLogout = (): logoutType => {

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const axios = useAxios()
  const authService = useAuthService()

  const logout = useCallback(async (navigateToAfter?: string) => {
    // Call logout API first (while token is still valid)
    try {
      await authService.logout()
    } catch (error) {
      console.error('[useLogout] Logout API error:', error);
      // Continue with local logout even if API fails
    }

    // Clear token and storage
    await axios.setToken(false)
    await StorageService.removeStorageItem(AUTH_TOKEN_KEY);
    await StorageService.removeStorageItem(USER_DETAILS_KEY);
    await StorageService.removeStorageItem(SELECTED_WORKSPACE_KEY);
    queryClient.clear()

    // Notify background script to sync logout to web app
    try {
      chrome.runtime.sendMessage({
        action: 'logout_from_extension'
      });
    } catch (error) {
      console.error('[useLogout] Error sending logout message:', error);
    }

    if (navigateToAfter) {
      navigate(navigateToAfter);
    } else {
      navigate('/');
    }
  }, [queryClient, navigate, axios, authService])

  return logout
}

export default useLogout
